import React from "react";
import { X as XIcon } from "lucide-react";

/**
 * Full-screen image preview. Closes on backdrop click, ESC key, or X button.
 * `lightbox` shape: { src: string, alt?: string } | null
 */
export const Lightbox = ({ lightbox, onClose }) => {
  if (!lightbox) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 cursor-zoom-out animate-in fade-in duration-200"
      onClick={onClose}
      data-testid="product-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Anteprima immagine prodotto"
    >
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full transition-colors z-10"
        aria-label="Chiudi anteprima"
        data-testid="product-lightbox-close"
      >
        <XIcon className="w-6 h-6" />
      </button>
      <img
        src={lightbox.src}
        alt={lightbox.alt}
        className="max-w-full max-h-[90vh] object-contain shadow-2xl rounded animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      />
      {lightbox.alt && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white text-sm px-4 py-2 rounded-full max-w-[90vw] truncate">
          {lightbox.alt}
        </div>
      )}
    </div>
  );
};
